/* eslint-disable no-undef */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { CheckSessionAction } from "store/middlewares/session/auth";
import LazyLoading from "components/fallbackUI/LazyLoading";
import { urls } from "config/urls";
import LatestTermsModal from "components/molecules/LatestTermsModal";
import { openCenterModal } from "store/slices/CenterModal.slice";

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const type = searchParams.get("type");
  const token = searchParams.get("token");

  const hasLocalToken = Boolean(
    JSON.parse(localStorage.getItem("bigfoot-drive") || "{}")?.user?.token,
  );

  const { isAuthenticated, isLoading, user } = useSelector(
    (state) => state.auth,
  );

  const isPublicShareLink =
    location.pathname.toLowerCase().startsWith("/drive/sharelink/") &&
    type === "public" &&
    Boolean(token);

  // const isPublicFolder = location.pathname.startsWith("/drive/sharelink/public")

  useEffect(() => {
    if (!isAuthenticated || user?.has_accepted_latest_terms !== false) return;

    dispatch(
      openCenterModal({
        content: <LatestTermsModal />,
        maxWidth: "1200px",
        disableClose: true,
      }),
    );
  }, [dispatch, isAuthenticated, user?.has_accepted_latest_terms]);

  useEffect(() => {
    if (isPublicShareLink && !hasLocalToken) {
      return;
    }
    dispatch(CheckSessionAction({ appType: "drive" }));
  }, [dispatch, isPublicShareLink, hasLocalToken]);

  if (isPublicShareLink) {
    return <Outlet />;
  }

  if (isLoading && !isAuthenticated) {
    return <LazyLoading />;
  }

  if (!isAuthenticated) {
    const redirectUrl = `${window.location.origin}${location.pathname}${location.search}`;

    const accountLoginUrl = `${
      urls.ACCOUNT_URL
    }?redirect=${encodeURIComponent(redirectUrl)}`;

    window.location.href = accountLoginUrl;

    return null;
  }

  return <Outlet />;
};

export default ProtectedRoute;
